import { render, staticRenderFns } from "./addBillOfLadingGoodsModal.vue?vue&type=template&id=389ae162&scoped=true"
import script from "./addBillOfLadingGoodsModal.vue?vue&type=script&lang=js"
export * from "./addBillOfLadingGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./addBillOfLadingGoodsModal.vue?vue&type=style&index=0&id=389ae162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ae162",
  null
  
)

export default component.exports